@if (show && productType) {
  <div class="d-flex flex-column">
    <div class="d-flex justify-content-between px-1">
      <div>
        {{ productType }}
      </div>
      <div>
        {{ price }}
      </div>
    </div>

    <div class="input-group hide-number-scroll">
      <input
        type="number"
        class="form-control"
        [value]="params.value"
        (blur)="updateQuantity($event)"
        (keyup.enter)="updateQuantity($event)"
      />
      <span class="input-group-text">{{ unitOfMeasure }}</span>
    </div>

    <div class="d-flex justify-content-between align-items-center">
      <button type="button" class="btn btn-primary" (click)="params.add(rowData)">
        <i class="fa fa-plus"></i>
      </button>

      @if (canMinus) {
        <button type="button" class="btn btn-info" (click)="params.minus(rowData)">
          <i class="fa fa-minus"></i>
        </button>
      }

      @if (canDelete) {
        <button type="button" class="btn btn-danger" (click)="params.remove(rowData)">
          <i class="fa fa-trash-alt"></i>
        </button>
      }
    </div>

    <div class="d-flex justify-content-between px-1">
      <div>
        <strong i18n>Total</strong>
      </div>
      <div>
        <strong>{{ total }}</strong>
      </div>
    </div>
  </div>
}
